<template>
  <div v-resize="DomResize" class="target-wrap" ref="targetwrapper"
       :class="`${getClass(itemInfos)} ${targetRightViewClass('target')}`">
  </div>
</template>

<script>
// import {uuid} from 'vue-uuid';
import { genUUID } from "@/services/common";
import { debounce } from "@/components/editor/common";
import { mapGetters } from 'vuex';

export default {
  name: "ContenteditableTargetHTML",
  props: ['itemInfos', 'flag', 'isPreMts', 'type'],
  data() {
    return {
      SPECIAL_LANGUAGE: SPECIAL_LANGUAGE,
      correctNodes: [],
      children: [],
      left: require("../assets/images/left.png"),
      right: require("../assets/images/right.png"),
      position: require("../assets/images/position.png"),
      items: [],
      value: "",
      atomMap: {},
      targetDom: null,//tag元素
      cloneDom: null,
      // info:""
    };
  },
  watch: {
    flag: {
      handler(value) {
        if (value === this.itemInfos.id + "target") {
          this.clearCorrect()
        } else if (!value) {
          this.getCorrect()
        }
      },
      deep: true
    },

    itemInfos: {
      handler() {
        setTimeout(() => {
          this.getCorrect()
        }, 500)
        this.items = this.getListItem();
        this.renderHtml();
        //修改为 HTML 拼接渲染，解决 v-for 不能清除部分标签
        // if (this.$refs.targetwrapper) {
        //   this.$refs.targetwrapper.innerHTML = this.getRenderHtml();
        // }
      },
      deep: true,
      immediate: true
    },
    getCurrentSentenceIdInfo: {
      handler() {
        //  let timer=setTimeout(()=>{
        this.items = this.getListItem();
        this.bus.$on("changeFlag", (flag) => {
          flag && this.renderHtml();
        })
        if (this.$refs.targetwrapper) {
          this.$refs.targetwrapper.innerHTML = this.getRenderHtml();
        }
        //  },1000)
      },
      deep: true,
    },
    getEditorFontSizeInfo: {
      handler(val) {
        if (val) {
          // console.log(val, "val");
          this.getCorrect()
        }
      }
    }
  },
  computed: {
    ...mapGetters('editor', [
      'getUrlInfo'
    ]),
    getCurrentSentenceIdInfo() {
      return this.$store.getters['editor/getCurrentSentenceIdInfo'];
    },
    getLoadingInfo() {
      return this.$store.getters["editor/getLoading"];
    },
    getEditorFontSizeInfo() {
      return this.$store.getters["editor/getEditorFontSizeInfo"];
    },
    getProjectInfo() {
      return this.$store.getters["editor/getProjectInfo"];
    },

  },
  mounted() {
    this.$nextTick(() => {
      if (window.navigator.userAgent.indexOf("MSIE") === -1) {
        this.observer();
      }
      //this.$refs.targetwrapper.innerHTML = this.getRenderHtml();
      this.renderHtml();
      // this.$refs.targetwrapper.childNodes.forEach(item => {
      //   if (item.nodeName === "SPAN") {
      //     item.addEventListener('click', (e) => {
      //       let info = e.target.getAttribute('info')
      //       let key = info.slice(info.indexOf('{') + 1, info.indexOf('}'))
      //       console.log(key, "key");
      //     })
      //   }
      // })
    })
    //   window.setTimeout(() => {
    //   this.$store.dispatch('editor/setTargeteditEditorStatus', 'false')
    // }, 500)
  },
  directives: {
    resize: { // 指令的名称
      bind(el, binding) { // el为绑定的元素，binding为绑定给指令的对象
        let width = '', height = '';
        function isReize() {
          const style = document.defaultView.getComputedStyle(el);
          if (width !== style.width || height !== style.height) {
            binding.value({ width: style.width, height: style.height });  // 关键(这传入的是函数,所以执行此函数)
          }
          width = style.width;
          height = style.height;
        }

        el.__vueSetInterval__ = setInterval(isReize, 300);
      },
      unbind(el) {
        // console.log(el, "解绑");
        clearInterval(el.__vueSetInterval__);
      }
    }
  },
  methods: {
    /**
    * @desc 特殊语种样式处理
    * @param {source} 源语言/目标语言
    * @returns {string} 返回样式类名
    */
    targetRightViewClass(source) {
      const { targetLang } = this.getUrlInfo
      if (source === 'target') {
        return this.SPECIAL_LANGUAGE.indexOf(targetLang) !== -1 ? 'right-view' : ''
      }
    },
    getListItem() {
      const self = this;
      let newTagTargetSent = Array();
      let reg = /<[^>]+>/g;
      let targetSent = Array();
      let targetHTML = Array();
      let currentSentenceInfo = this.$store.getters['editor/getCurrentSentenceIdInfo'];
      // console.log(currentSentenceInfo.currentId, "currentSentenceInfo.currentId");
      let currentSentenceInfoLength = Object.keys(currentSentenceInfo);
      if (!!(self.itemInfos) && !!(self.itemInfos.tagTargetSent)) {
        const tagTargetSent = (JSON.parse(self.itemInfos.tagTargetSent));
        if (!!tagTargetSent && (tagTargetSent.fragments) && !!(tagTargetSent.fragments.length) && (tagTargetSent.fragments[0].atoms)) {
          targetSent = (tagTargetSent.fragments[0].atoms);
        }
      }
      (targetSent).forEach((item) => {
        if (((item.dataType) === 'text')) {
          if (item.data) {
            // item.data = item.data.replace(/ /g,'\u00a0')
            if (reg.test(item.data)) {
              let arrEntities = { 'lt': '<', 'gt': '>', 'amp': '&' };
              let dataHTMLResult = (item.data).replace(/&(lt|gt|amp);/ig, function (all, t) {
                return arrEntities[t];
              });
              Reflect.set(item, 'data', dataHTMLResult);
            }
          }
        }
      });
      newTagTargetSent = [...targetSent];
      return (newTagTargetSent);
    },
    reverse(str) {
      // str = str.replace(/</g, "&lt;");
      // str = str.replace(/>/g, "&gt;");
      return str;
    },
    setStyle(str) {
      // console.log(str);
      if (str) {
        let arr = str.split(';')
        return arr.filter(item => {
          if (item && item.indexOf('font-size') == -1) {
            return item;
          }
        }).join(";");
      }
    },
    getRenderHtml() {
      let html = "";
      this.atomMap = {};
      let idx = 0;
      this.items.forEach(item => {
        let info = this.getInfo(item, this.itemInfos)
        let style = this.setStyle(item.style) ? this.setStyle(item.style) : "";
        if ((item.tagType) === 'text' || (item.tagType) === 'html') {
          if (style) {
            style = style.replace('color:#FFFFFF', "")
          }
          info ? html += `<span class="text" info="${info}" style='${style}'>${item.searchState ? item.dataHTML : this.reverse(item.data)}</span>` :
            html += `<span class="text" info="${info}" style='${style}'>&nbsp;${item.searchState ? item.dataHTML : this.reverse(item.data)}</span>`
        }
        //  else if ((item.tagType) === 'open' || (item.tagType) === 'close') {
        //   let img = this.getImgInfo(item);
        //   let id = this.itemInfos.id + item.tagType + idx++;
        //   this.atomMap[id] = item;
        //   html += `<img alt="此处为链接" src="${img}" title="此处为链接" info="${info}" class="tag-img" width="25px"  draggable="true" id="target-tag-${id}"/>`
        // } else if ((item.tagType) === 'placeholder') {
        //   let id = this.itemInfos.id + item.tagType + idx++;
        //   this.atomMap[id] = item;
        //   html += `<img alt="此处为链接" src="${this.position}" id="target-tag-${id}" title="此处为链接" info="${info}" class="placeholder" draggable="true"/>`
        // }
      });
      return html;
    },
    renderHtml() {
      let self = this
      //修改为 HTML 拼接渲染，解决 v-for 不能清除部分标签
      if (this.$refs.targetwrapper) {
        this.$refs.targetwrapper.innerHTML = this.getRenderHtml()
        if (navigator.userAgent.indexOf("Firefox") > 0) {
          for (let key in this.atomMap) {
            if (key === undefined) { return }
            self.targetDom = document.getElementById("target-tag-" + key);
            let dragstartLength = [];
            //  拖动tag
            self.targetDom.addEventListener("dragstart", function (event) {
              // console.log("拖动")
              let ele = event.target.parentNode;
              ele.childNodes.forEach(item => {
                if (item.nodeName !== "SPAN") {
                  dragstartLength.push(item)
                }
              })
            });
            self.targetDom.addEventListener("dragend", function (event) {
              let ele = event.target.parentNode;
              let dragendLength = [];
              ele.childNodes.forEach(item => {
                if (item.nodeName !== "SPAN") {
                  dragendLength.push(item)
                }
              })
              if (ele.getAttribute('contenteditable') !== "false") {
                if (dragendLength.length === dragstartLength.length + 1) {
                  event.target.parentNode.removeChild(event.target)
                }
                ele.blur();
                // console.log("拖动完触发");
                setTimeout(() => {
                  self.renderHtml();
                }, 1000)
              }
            });
          }
        }
      }
    },
    DomResize() {
      this.$nextTick(() => {
        if (!this.flag && !this.getLoadingInfo) {
          this.getCorrect()
        }
      })
    },
    //观察器
    observer() {
      const self = this
      const dom = document.getElementById("target-" + self.itemInfos.id)
      const MutationObserver = window.MutationObserver || window.WebKitMutationObserver || window.MozMutationObserver;//浏览器兼容
      const config = { characterData: true, childList: true, subtree: true }//配置对象
      const callback = function () {
        if (!self.flag && !this.getLoadingInfo) {
          self.getCorrect()
        }
        // if (!!document.getElementsByTagName("object")) {
        //   document.getElementsByTagName("object").forEach(item => {
        //     item.remove()
        //   })
        // }

      }
      const observer = new MutationObserver(debounce(callback, 100));
      observer.observe(dom, config);
    },
    getCorrect() {
      if (window.navigator.userAgent.indexOf("MSIE") >= 0) {
        return;
      }
      // console.log(this.itemInfos.targetTermSent)
      this.clearCorrect()
      if (!this.itemInfos.targetTermSent || !this.itemInfos.targetTermSent.length) {
        return;
      }
      this.label()
      this.setCorrect()
    },
    //判断选中文本是否换行
    wrapSent(startNode, endNode, start, end, idObj) {
      const range = document.createRange()
      const rangeH = document.createRange()
      // //选择区间
      range.setStart(startNode, start)
      range.setEnd(endNode, end)
      rangeH.setStart(startNode, start)
      rangeH.setEnd(endNode, start + 1)
      const sentHeight = range.getBoundingClientRect().height;
      const textHeight = rangeH.getBoundingClientRect().height;
      let str1 = range.toString().replace(/\u00a0/g, " ")
      let str2 = idObj.text.replace(/\u00a0/g, " ")
      if (str1 !== str2) {
        return false
      }
      if (sentHeight > textHeight) {
        return true
      } else {
        return false
      }
    },
    clearCorrect() {
      const df = document.getElementById("target-df" + this.itemInfos.id)
      if (df) {
        df.innerHTML = "";
      }
    },
    setCorrect() {
      const { targetTermSent } = this.itemInfos;
      if (Array.isArray(targetTermSent) && targetTermSent.length) {
        targetTermSent.forEach(cor => {
          let startNode, endNode, start, end
          this.children.forEach(child => {
            if (cor.textIndex >= child.start && cor.textIndex < child.end && !startNode) {
              startNode = child
            }
            if (cor.textIndex + cor.textLength >= child.start && cor.textIndex + cor.textLength <= child.end && !endNode) {
              endNode = child
            }
          })
          if (startNode && endNode) {
            start = cor.textIndex - startNode.start
            end = cor.textIndex + cor.textLength - endNode.start
            this.correctNodes.push({
              startNode: startNode.node,
              endNode: endNode.node,
              start,
              end,
              index: cor.textIndex
            })
            //console.log(this.correctNodes,'this.correctNodes')
            this.rangeFun(startNode.node, endNode.node, start, end, cor)
          }
        })
      }
    },
    rangeFun(startNode, endNode, start, end, idObj) {
      // console.log(startNode,endNode,start,end,idObj)
      const dom = document.getElementById("target-df" + this.itemInfos.id)
      const domVw = dom.getBoundingClientRect()
      const top = dom.scrollTop
      const range = document.createRange()
      // let rangeH
      const isWrap = this.wrapSent(startNode, endNode, start, end, idObj)
      if (isWrap) {
        //  换行选择
        for (let i = start; i < end; i++) {
          range.setStart(startNode, i)
          range.setEnd(endNode, i + 1)
          const obj = {
            isFirst: i === start,
            isEnd: i === end - 1,
          };
          this.setRangeDiv(idObj, range, domVw, top, obj);
        }
      } else {
        range.setStart(startNode, start)
        range.setEnd(endNode, end)
        let str1 = range.toString().replace(/\u00a0/g, " ")
        let str2 = idObj.text.replace(/\u00a0/g, " ")
        if (str1 !== str2) return;
        const obj = {
            isFirst: true,
            isEnd: true,
          };
          this.setRangeDiv(idObj, range, domVw, top, obj);
      }
    },
    setRangeDiv(idObj, range, domVw, top, isStartOrEnd) {
      // console.log(idObj,range,domVw,top,rangeH)
      const rect = range.getBoundingClientRect()
      const div = document.createElement('div')
      const { isFirst, isEnd } = isStartOrEnd;
      const classNames = ["correct-item"];
      if (isFirst) {
        classNames.push("correct-item-start");
      }
      if (isEnd) {
        classNames.push("correct-item-end");
      }
      div.classList.add(...classNames);
      // div.classList.add('correct-item')
      div.style.pointerEvents = 'auto'
      div.style.left = rect.left - domVw.left + 'px'
      div.style.width = rect.width  + 'px'
      // div.style.height = rect.height + 'px'
      div.style.height = 1 + 'px'
      div.style.top = rect.top + top - domVw.top - 4 + 'px'
      div.style.position = "absolute"
      // div.style.background = "#0167FF"
      div.style.borderTop = "2px solid #ff9c00";
      // div.style.opacity = "0.5"
      const df = document.getElementById("target-df" + this.itemInfos.id)
      df.appendChild(div)
    },
    //数据处理
    label() {
      this.setCorrectHTML()
      const div = document.getElementById("target-" + this.itemInfos.id)
      let children = []
      this.children = []
      this.setTextNode(children, div)
      this.children = children
    },
    //递归获取text节点
    setTextNode(children, div) {
      const childNodes = div.childNodes
      for (let i = 0; i < childNodes.length; i++) {
        const element = childNodes[i]
        if (element.childNodes.length > 1) {
          this.setTextNode(children, element)
        } else if (element.nodeType === 3) {
          const node = element
          const len = children.length ? children[children.length - 1].end : 0
          children.push({ node, start: len, end: node.length + len })
        } else if (element.firstChild && element.firstChild.nodeType === 3) {
          const node = element.firstChild
          const len = children.length ? children[children.length - 1].end : 0
          children.push({ node, start: len, end: node.length + len })
        } else {
          this.setTextNode(children, element)
        }
      }
    },
    setCorrectHTML() {
      this.$nextTick(() => {
        const dom = document.getElementById("target-" + this.itemInfos.id)
        // console.log(dom)
        const h = dom.offsetHeight
        const w = dom.offsetWidth
        const df = document.getElementById(`target-df${this.itemInfos.id}`)
        df.style.height = h + 'px'
        df.style.width = w + 'px'
        df.style.padding = "4px 8px"
      })
    },
    //译文高亮
    getInfo(row, itemInfos) {
      let infos;
      if (Object.keys(row).length) {
        infos = `${(row.atomKey) || (itemInfos.templateKey)}*${(row.dataType) || 'text'}*${(row.id) || `${parseInt((itemInfos.id).toString().substr(0, 5))}`}*${(row.sort) || `${parseInt((itemInfos.id).toString().substr(0, 5))}`}*${(row.style) || 'style'}*${(row.tagType) || 'text'}*${genUUID()}`;
        if (row.dataType === "tag") {
          infos = `${infos}*${(row.data) || 1}`
        }
      }
      return infos
    },

    getClass(row) {
      if (!!row && !!(row.tagTargetSent)) {
        let tagTargetSent = JSON.parse(row.tagTargetSent);
        if (!!tagTargetSent && !!(tagTargetSent.fragments) && !!(tagTargetSent.fragments.length)) {
          let firstChild = tagTargetSent.fragments[0];
          if (!!firstChild && !!(firstChild.atoms) && !!(firstChild.atoms.length)) {
            let firstChildAtoms = firstChild.atoms[0];
            if ((firstChildAtoms.dataType !== 'tag') && !(firstChildAtoms.data)) {
              return 'target-wrap-empty'
            }
          }
        }
      }
    },
    getImgInfo(info) {
      if ((info.tagType) === 'open') {
        if (info.data) {
          return info.data < 10 ? require(`../assets/images/left_0${info.data}.png`) : require(`../assets/images/left_${info.data}.png`);
        }
      } else if ((info.tagType) === 'close') {
        if (info.data) {
          return info.data < 10 ? require(`../assets/images/right_0${info.data}.png`) : require(`../assets/images/right_${info.data}.png`);
        }
      }
    }
  }
}
</script>
<!-- <style lang="less" >
.df .correct-item-start::before {
  content: "";
  position: absolute;
  left: 0;
  top: 0px;
  width: 2px;
  height: 2px;
  background-color: #ff9c00;
}
.df .correct-item-end::after {
  content: "";
  position: absolute;
  right: 0px;
  top: 0px;
  width: 2px;
  height: 2px;
  background-color: #ff9c00;
}
</style> -->

<style scoped lang="less">
.df {
  position: absolute;
  pointer-events: none;
  top: 0;
  left: 0;
  .correct-item {
    position: absolute;
  }
}

/deep/ .placeholder {
  width: 15px !important;
  z-index: 1000;
}

/deep/ .text {
  word-break: normal !important;
}
// .target-wrap{
//   word-break: break-all;
// }
</style>
